import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { getBrands } from "../actions/ApiCalls";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import './app.css';
import ProductFilter from "../Components/ProductFilter";
import { isMobile } from "react-device-detect";

function Brands() {
    const [brands, setBrands] = useState<any[]>([]);
    const [filteredBrands, setFilteredBrands] = useState<any[]>([]);
    const [filterMode, setFilterMode] = useState<'fixed' | 'scroll'>('fixed');

    const winesUrl = 'https://vinimark.s3.amazonaws.com/web/';
    const navigate = useNavigate();
    const filterRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.title = "Vinimark | Our Partners";
        getBrands()
            .then(response => {
                setBrands(response.data);
                setFilteredBrands(response.data);
            })
            .catch(error => console.error("Failed to fetch brands:", error));
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setFilterMode('scroll');
                } else {
                    setFilterMode('fixed');
                }
            },
            { threshold: 0.1 }
        );

        if (filterRef.current) {
            observer.observe(filterRef.current);
        }

        return () => {
            if (filterRef.current) {
                observer.unobserve(filterRef.current);
            }
        };
    }, []);

    const handleBrandClick = (brand: any) => {
        const searchName = brand.search_name || brand.name || brand.id;
        if (!searchName) {
            console.error('No valid identifier found for brand:', brand);
            return;
        }
        navigate(`/our-wines/${searchName}`);
    }

    const handleFilterChange = (filteredResults: any[]) => {
        setFilteredBrands(filteredResults);
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            <Header />

            <main style={{
                flex: '1',
                paddingTop: isMobile ? '70px' : '90px',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div className="brands-container" style={{ flex: 1 }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: window.innerWidth > 575 ? 'row' : 'column',
                        marginBottom: isMobile ? '48px' : '72px'
                    }}>
                        <div style={{ flex: 1 }} />
                        <div style={{
                            flex: 1,
                            textAlign: 'left',
                            paddingLeft: isMobile ? '24px' : '46px',
                            paddingRight: isMobile ? '24px' : '0'
                        }}>
                            <div style={{ width: isMobile ? '100%' : '75%' }}>
                                <h2 className='our-story-title'>OUR PARTNERS</h2>
                                <p className="brands-description">
                                    Vinimark represents more than 60 South African wine brands as well as Champagnes Bollinger, Nicolas Feuillatte, and Pommery. Leveraging the collective strength of our portfolio, we always look to forge new opportunities to propel the success of both our brand and trade partners.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="brands-grid" style={{
                        marginBottom: isMobile ? '48px' : '72px'
                    }}>
                        {filteredBrands.map((brand, index) => (
                            <img
                                key={index}
                                src={`${winesUrl}${brand.image_path_bw || brand.image_path}`}
                                alt={brand.name || `Brand ${index}`}
                                className="brand-logo"
                                onClick={() => handleBrandClick(brand)}
                                style={{
                                    cursor: 'pointer',
                                    filter: brand.image_path_bw ? 'none' : 'grayscale(100%)',
                                }}
                            />
                        ))}
                    </div>
                </div>

                <div className="filter-container" ref={filterRef} style={{
                    position: 'relative',
                    zIndex: 10
                }}>
                    <ProductFilter
                        brands={brands}
                        onFilterChange={handleFilterChange}
                        mode={filterMode}
                    />
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default Brands;
